import errorLog from '@/store/modules/sessionState/indicators/errorLog';
import fetch from '@/store/modules/sessionState/indicators/fetch';
import loading from '@/store/modules/sessionState/indicators/loading';

export default {
    errorLog,
    fetch,
    loading,
};
